import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["title"];
import { pageSizeOptionList } from '@/constants';
import { computed, toRefs, onMounted, onUnmounted, ref, } from 'vue';
import { getGlobalStore } from '@/lib/global-store';
import { i18n } from '@/locales';
import { tableScrollTop } from '@/utils/tableScrollTop';
import { workerBaromoneyHistoryTableHeader } from '@/constants/workerBaromoneyHistory/workerBaromoneyHistoryTableHeader';
import { sortTypeEnum } from '@/constants/global';
import BrgPagination from '@/components/BrgPagination.vue';
import Select from '@/components/Form/Select.vue';
const lc = 'views.worker.worker_baromoney_history.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'WorkerBaromoneyHistoryTable',
    props: {
        isFetching: { type: Boolean },
        isError: { type: Boolean }
    },
    setup(__props) {
        const locale = {
            onFetching: i18n.t(`${lc}on_fetching`),
            dataCanNotLoad: i18n.t(`${lc}data_can_not_load`),
            noDataText: i18n.t(`${lc}no_data_text`),
            noSearchDataText: i18n.t('common.no_search_data_text'),
            noSearchData: i18n.t(`${lc}no_search_data`),
        };
        const props = __props;
        const { isFetching, isError, } = toRefs(props);
        const vuexStore = getGlobalStore();
        const workerBaromoneyHistoryList = computed(() => vuexStore.state.workerBaromoneyHistory.workerBaromoneyHistoryList);
        const getterSearchKey = computed(() => vuexStore.getters['workerBaromoneyHistory/getterSearchKey']);
        const paginationData = computed(() => vuexStore.state.workerBaromoneyHistory.paginationData);
        const currentPage = computed({
            get() {
                return paginationData.value.pageNumber;
            },
            set(pageNumber) {
                vuexStore.dispatch('workerBaromoneyHistory/setPageNumber', pageNumber);
            },
        });
        const noDataText = computed(() => {
            if (isFetching.value) {
                return locale.onFetching;
            }
            if (isError.value) {
                return locale.dataCanNotLoad;
            }
            if (getterSearchKey.value) {
                return locale.noSearchDataText;
            }
            return locale.noDataText;
        });
        const setSortOption = (payload) => {
            vuexStore.dispatch('workerBaromoneyHistory/setSortOption', payload);
        };
        const sortBy = ref([
            {
                key: '',
                order: sortTypeEnum.ASC,
            },
        ]);
        /**
         * 테이블 정렬 객체 업데이트 이벤트 핸들러
         */
        const handleUpdateSortBy = (value) => {
            sortBy.value = value;
            if (value.length === 0) {
                setSortOption([
                    {
                        field: '',
                        value: '',
                    },
                ]);
                return;
            }
            const { key, order, } = value[0];
            setSortOption([
                {
                    field: key,
                    value: order,
                },
            ]);
        };
        /**
         * worker-baromoney-history-detail-dialog에 기본값을 셋팅하여 다이얼로그를 오픈합니다.
         */
        const openDetailDialog = (item) => {
            // 필수값
            const { hubId, workerName, workerCode, } = item._workerBaromoneyHistory;
            // 기본값을 위한 조회 기간
            const { fromDate, toDate, } = vuexStore.state.workerBaromoneyHistory.filterOption;
            vuexStore.dispatch('workerBaromoneyHistoryDetailDialog/setDialogDetail', {
                hubId,
                workerName,
                workerCode,
                fromDate,
                toDate,
            });
        };
        /**
         * 테이블 row 더블클릭 핸들러
         */
        const handleDbClickRow = (event, { item, }) => {
            openDetailDialog(item);
        };
        const tableRef = ref(null);
        let unsubscribe;
        // 페이지 사이즈
        const pageSize = computed({
            get() {
                return vuexStore.state.workerBaromoneyHistory.pageSize;
            },
            set() { },
        });
        const handleChangePageSizeSelector = (value) => {
            vuexStore.dispatch('workerBaromoneyHistory/setPageSize', value);
        };
        // 1. 엘리먼트 생성 후 실행
        onMounted(() => {
            unsubscribe = tableScrollTop(vuexStore, tableRef?.value.$el);
        });
        // 2. 페이지 이탈시 구독 취소
        onUnmounted(() => {
            unsubscribe();
        });
        return (_ctx, _cache) => {
            const _component_v_data_table = _resolveComponent("v-data-table");
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(_component_v_data_table, {
                    ref_key: "tableRef",
                    ref: tableRef,
                    hover: "",
                    class: "worker-baromoney-history-table brg-table",
                    "hide-default-footer": "",
                    "fixed-header": "",
                    density: "compact",
                    headers: _unref(workerBaromoneyHistoryTableHeader),
                    "no-data-text": noDataText.value,
                    items: workerBaromoneyHistoryList.value,
                    "items-per-page": -1,
                    "sort-by": sortBy.value,
                    "onUpdate:sortBy": handleUpdateSortBy,
                    "onDblclick:row": handleDbClickRow
                }, {
                    [`item.formattedContent`]: _withCtx(({ item }) => [
                        _createElementVNode("span", {
                            title: item.formattedContent
                        }, _toDisplayString(item.formattedContent), 9 /* TEXT, PROPS */, _hoisted_1)
                    ]),
                    bottom: _withCtx(() => _cache[1] || (_cache[1] = [])),
                    _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["headers", "no-data-text", "items", "sort-by"]),
                _createVNode(BrgPagination, {
                    modelValue: currentPage.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((currentPage).value = $event)),
                    length: paginationData.value.pages
                }, {
                    end: _withCtx(() => [
                        _createVNode(Select, {
                            class: "page-size-wrapper mini",
                            value: pageSize.value,
                            items: _unref(pageSizeOptionList),
                            "on-change": handleChangePageSizeSelector
                        }, null, 8 /* PROPS */, ["value", "items"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "length"])
            ]));
        };
    }
});
